module.exports = __webpack_public_path__ + "static/media/searchSvg.0822306f.svg";